import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ADMISSION_MODAL_STEP_BOTTLE_SERVICE,
  ADMISSION_MODAL_STEP_GUEST_LIST,
  ADMISSION_MODAL_STEP_TICKET,
} from '@components/admission-modal/admission-modal.type';
import { IconBottleService, IconGuestList, IconTicket } from '@components/icons';
import { ModalStickyHeader } from '@components/modals/modal-sticky-header';
import { SelectItemOption } from '@components/select-item-option';
import classNames from 'classnames';

import { Props } from './preset-type-modal.type';

export const PresetTypeModal = ({ handleClose, setStep }: Props) => {
  const { t } = useTranslation();

  const presets = useMemo(() => {
    return [
      {
        id: 'ticket',
        name: t('offers:admissionTicket'),
        className: 'hover:bg-purple-50',
        icon: IconTicket,
        action: () => setStep(ADMISSION_MODAL_STEP_TICKET),
      },
      {
        id: 'table-service',
        name: t('offers:admissionTableService'),
        className: 'hover:bg-orange-50',
        icon: IconBottleService,
        action: () => setStep(ADMISSION_MODAL_STEP_BOTTLE_SERVICE),
      },
      {
        id: 'guest-list',
        name: t('offers:admissionGuestList'),
        className: 'hover:bg-pink-50',
        icon: IconGuestList,
        action: () => setStep(ADMISSION_MODAL_STEP_GUEST_LIST),
      },
    ];
  }, [t, setStep]);

  return (
    <>
      <ModalStickyHeader title={t('offers:createNewAdmissionTitle')} handleClose={handleClose} bordered={true} />
      <div className='max-w-xl px-4 md:px-7 mt-5 mb-8 md:my-12 mx-auto'>
        <div className='grid grid-cols-1 sm:grid-cols-3 gap-3'>
          {presets.map((preset) => (
            <SelectItemOption {...preset} key={preset.id} className={classNames(preset.className)} />
          ))}
        </div>
      </div>
    </>
  );
};
